var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ActivatedRoute, Router } from '@angular/router';
import { InfluencerService } from '../../services/influencer/influencer.service';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '../../services/modal/modal.service';
import { StringUtils } from '../../utils/string.utils';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { EventTrackerService, UserActionType, Page, ActionSource, ActionDetails, TargetType } from '../../services/event-tracker/event-tracker.service';
import { CampaignService } from '../../services/campaign/campaign.service';
import { UserService } from '../../services/user.service';
import { InfluencerRequestError } from '../influencer-details/fail-retrieve-campaign-modal/fail-retrieve-campaign-modal.component';
import { platformIconPath, ChannelStatus, CommonConstant } from '../../app.constants';
import { AuthService } from '../../core/auth.service';
export var AllSetPageType;
(function (AllSetPageType) {
    AllSetPageType["CAMPAIGN_INVITATION"] = "campaign_invitation";
    AllSetPageType["CONTACT_PERMISSION"] = "contact_permission";
})(AllSetPageType || (AllSetPageType = {}));
var InfluencerAllSetComponent = /** @class */ (function () {
    function InfluencerAllSetComponent(activatedRoute, router, influencerService, translate, modalService, route, auth, eventTracker, campaignService, userService) {
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.influencerService = influencerService;
        this.translate = translate;
        this.modalService = modalService;
        this.route = route;
        this.auth = auth;
        this.eventTracker = eventTracker;
        this.campaignService = campaignService;
        this.userService = userService;
        this.listExistingChannel = [];
        this.isDeclined = false;
        this.isAcceptedOrRejected = false;
    }
    InfluencerAllSetComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.currentInfluencer = this.userService.getInfluencerInfo();
        this.getQueryParams();
        if (this.campaignId) {
            this.campaignService.getCampaignOfInfluencer(this.currentInfluencer.id, this.campaignId).subscribe(function (res) {
                _this.campaignData = res[0];
            });
        }
        this.loadInfluencerChannels(this.currentInfluencer.id);
    };
    InfluencerAllSetComponent.prototype.getQueryParams = function () {
        var _this = this;
        this.activatedRoute.queryParams.subscribe(function (params) {
            if (!_this.isValidLink(params.requestType)) {
                return _this.router.navigate(['influencer', 'login']);
            }
            _this.requestType = params.requestType;
            if (params.permissionToken) {
                _this.permissionToken = params.permissionToken;
            }
            if (params.campaignInfluencerId) {
                _this.campaignInfluencer = Number(params.campaignInfluencerId);
            }
            if (params.inviteToken) {
                _this.inviteToken = params.inviteToken;
            }
            if (params.accessToken) {
                _this.accessToken = params.accessToken;
            }
            if (params.campaignId) {
                _this.campaignId = Number(params.campaignId);
            }
            if (params.isNewCampaign) {
                _this.isNewCampaign = params.isNewCampaign;
            }
            if (params.influencerName) {
                _this.influencerName = params.influencerName;
            }
            if (params.advertiserName) {
                _this.advertiserName = params.advertiserName;
            }
            if (params.company) {
                _this.agencyName = params.company;
            }
            if (params.permissionId) {
                _this.permissionId = Number(params.permissionId);
            }
            if (params.advertiserId) {
                _this.advertiserId = Number(params.advertiserId);
            }
        });
        this.urlQueryParams = combineLatest(this.activatedRoute.queryParams, function (queryParams) { return (__assign({}, queryParams)); });
        this.urlQueryParams.subscribe(function (qp) {
            if (qp.acceptionResult && qp.acceptionResult === 'false' || qp.declineResult && qp.declineResult === 'false') {
                _this.errorType = InfluencerRequestError.ACCEPT_OR_REJECT_API_FAIL;
                _this.modalService.openInCenter(_this.allSetPageErrorModal, null, 'all-set-page-error-modal', true);
            }
            if (qp.acceptionResult || _this.isContactPermissionRequest) {
                _this.title = _this.translate.instant('all_set.title');
            }
            if (qp.declineResult && _this.isCampaignInvitationRequest) {
                _this.isDeclined = true;
                _this.title = _this.translate.instant('all_set.rejected_title');
            }
            if (qp.declineResult && _this.isContactPermissionRequest) {
                _this.isDeclined = true;
                _this.title = _this.translate.instant('all_set.rejected_contact_permission_title');
            }
        });
    };
    InfluencerAllSetComponent.prototype.isValidLink = function (requestType) {
        return requestType && (requestType === AllSetPageType.CONTACT_PERMISSION || requestType === AllSetPageType.CAMPAIGN_INVITATION);
    };
    Object.defineProperty(InfluencerAllSetComponent.prototype, "isCampaignInvitationRequest", {
        get: function () {
            return this.requestType === AllSetPageType.CAMPAIGN_INVITATION;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerAllSetComponent.prototype, "isContactPermissionRequest", {
        get: function () {
            return this.requestType === AllSetPageType.CONTACT_PERMISSION;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerAllSetComponent.prototype, "permissionContent", {
        get: function () {
            if (!this.influencerName || !this.advertiserName || !this.agencyName) {
                return null;
            }
            var permissionParams = {
                influencerName: this.influencerName,
                advertiser: this.advertiserName,
                company: this.agencyName,
                advertiserName: this.advertiserName
            };
            if (!this.isDeclined && this.isContactPermissionRequest) {
                return this.translate.instant('all_set.content_permission', permissionParams);
            }
            else {
                return this.translate.instant('all_set.content_rejected_permission', permissionParams);
            }
        },
        enumerable: true,
        configurable: true
    });
    InfluencerAllSetComponent.prototype.acceptOrRejectPermission = function (isRetried) {
        this.isAcceptedOrRejected = true;
        if (!this.isDeclined) {
            this.rejectPermission(isRetried);
        }
        else {
            this.acceptPermission(isRetried);
        }
    };
    Object.defineProperty(InfluencerAllSetComponent.prototype, "revertPermissionLink", {
        get: function () {
            if (this.isDeclined) {
                return this.translate.instant('all_set.accept_permission_link');
            }
            else {
                return this.translate.instant('all_set.reject_permission_link');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerAllSetComponent.prototype, "revertCampaignInvitationLink", {
        get: function () {
            if (this.isDeclined) {
                return this.translate.instant('all_set.accept_campaign_link');
            }
            else {
                return this.translate.instant('all_set.reject_campaign_link');
            }
        },
        enumerable: true,
        configurable: true
    });
    InfluencerAllSetComponent.prototype.rejectPermission = function (isRetried) {
        var _this = this;
        this.isDeclined = true;
        this.title = this.translate.instant('all_set.rejected_contact_permission_title');
        this.modalService.close();
        this.influencerService.rejectContactPermission(this.permissionToken).subscribe(function (res) {
            _this.sendMixpanelEvent(_this.isDeclined);
            _this.notifySuccess(_this.translate.instant('all_set.success_permission_rejection'));
        }, function (error) {
            _this.handleErrorOnContactPermission(isRetried);
        });
    };
    InfluencerAllSetComponent.prototype.acceptPermission = function (isRetried) {
        var _this = this;
        this.modalService.close();
        if (!this.hasConfirmedAllChannels) {
            this.influencerService.resetContactPermission(this.permissionToken).subscribe(function (res) {
                return _this.redirectToPreviousPage();
            });
        }
        else {
            this.isDeclined = false;
            this.title = this.translate.instant('all_set.title');
            this.influencerService.acceptContactPermission(this.permissionToken).subscribe(function (res) {
                if (!isRetried) {
                    _this.sendMixpanelEvent(_this.isDeclined);
                }
                _this.notifySuccess(_this.translate.instant('all_set.success_permission_acception'));
            }, function (error) {
                _this.handleErrorOnContactPermission(isRetried);
            });
        }
    };
    InfluencerAllSetComponent.prototype.handleErrorOnContactPermission = function (isRetried) {
        this.isDeclined = true;
        this.title = this.translate.instant('all_set.rejected_contact_permission_title');
        if (!isRetried) {
            this.errorType = InfluencerRequestError.ACCEPT_OR_REJECT_API_FAIL;
        }
        this.modalService.openInCenter(this.allSetPageErrorModal, null, 'all-set-page-error-modal');
    };
    InfluencerAllSetComponent.prototype.declineOrAcceptCampaignInvitation = function (isRetried) {
        this.isAcceptedOrRejected = true;
        if (this.campaignInfluencer && !this.isDeclined) {
            this.declineCampaign(isRetried);
        }
        else {
            this.accpetCampaign(isRetried);
        }
    };
    InfluencerAllSetComponent.prototype.notifyError = function (errorMessage) {
        var _this = this;
        if (errorMessage && StringUtils.trim(errorMessage) !== '') {
            this.notificationType = this.translate.instant('notification.error');
            this.notificationMessage = errorMessage;
            this.modalService.open(this.allSetPageNotification, function () {
                _this.notificationType = null;
                _this.notificationMessage = null;
            }, true);
        }
    };
    InfluencerAllSetComponent.prototype.notifySuccess = function (successMessage) {
        var _this = this;
        if (successMessage && StringUtils.trim(successMessage) !== '') {
            this.notificationType = this.translate.instant('notification.success');
            this.notificationMessage = successMessage;
            this.modalService.open(this.allSetPageNotification, function () {
                _this.notificationType = null;
                _this.notificationMessage = null;
            }, true);
        }
    };
    InfluencerAllSetComponent.prototype.redirectToPreviousPage = function (isReAccept) {
        if (this.isContactPermissionRequest) {
            return this.route.navigate(['dashboard', 'contact-permission'], {
                queryParams: {
                    accessToken: this.accessToken,
                    permissionToken: this.permissionToken
                }
            });
        }
        return this.route.navigate(['dashboard', 'campaigns', this.campaignId, 'new'], {
            queryParams: {
                isNewCampaign: this.isNewCampaign,
                inviteToken: this.inviteToken,
                campaignInfluencerId: this.campaignInfluencer,
                isReAccept: isReAccept
            }
        });
    };
    InfluencerAllSetComponent.prototype.tryAgian = function () {
        if (!this.isAcceptedOrRejected) {
            this.redirectToPreviousPage();
        }
        else if (this.isAcceptedOrRejected && this.permissionToken) {
            this.acceptOrRejectPermission(true);
        }
        else {
            this.declineOrAcceptCampaignInvitation(true);
        }
    };
    InfluencerAllSetComponent.prototype.sendMixpanelEvent = function (isDeclined) {
        if (this.permissionToken) {
            this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CONTACT_PERMISSION, {
                type: TargetType.ACCOUNT,
                id: this.advertiserId,
                name: this.advertiserName
            }, {
                actionDetails: !isDeclined ? ActionDetails.INFLUENCER_REJECTED_REQUEST : ActionDetails.INFLUENCER_ACCEPTED_REQUEST,
                source: ActionSource.UNDO_LINK,
                permissionId: this.advertiserId,
                action: UserActionType.UPDATE
            }, undefined, null);
        }
        else {
            this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
                type: TargetType.CAMPAIGN,
                id: this.campaignInfluencer,
                name: this.campaignData && this.campaignData.campaign_name,
            }, {
                actionDetails: !isDeclined ? ActionDetails.INFLUENCER_REJECTED_REQUEST : ActionDetails.INFLUENCER_ACCEPTED_REQUEST,
                source: ActionSource.UNDO_LINK,
                campaignId: this.campaignId,
                action: UserActionType.UPDATE
            }, undefined, null);
        }
    };
    InfluencerAllSetComponent.prototype.declineCampaign = function (isRetried) {
        var _this = this;
        this.isDeclined = true;
        this.title = this.translate.instant('all_set.rejected_title');
        this.modalService.close();
        this.updateInfluencerCampaignInvitation(CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name).then(function (success) {
            _this.notifySuccess(_this.translate.instant('all_set.success_campaign_rejection'));
            if (!isRetried) {
                _this.sendMixpanelEvent(_this.isDeclined);
            }
        }, function (error) {
            _this.handleErrorOnCampaignInvitation(isRetried);
        });
    };
    InfluencerAllSetComponent.prototype.accpetCampaign = function (isRetried) {
        var _this = this;
        this.modalService.close();
        if (!this.hasConfirmedAllChannels) {
            var data = {
                accessLevel: 'influencer',
                id: this.campaignInfluencer,
                status: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.name,
            };
            this.influencerService.updateInfluencerCampaignStatus(data).subscribe(function (res) {
                return _this.redirectToPreviousPage(true);
            });
        }
        else {
            this.isDeclined = false;
            this.title = this.translate.instant('all_set.title');
            this.updateInfluencerCampaignInvitation(CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name).then(function (success) {
                if (!isRetried) {
                    _this.sendMixpanelEvent(_this.isDeclined);
                }
                _this.notifySuccess(_this.translate.instant('all_set.success_campaign_acception'));
            }, function (error) {
                _this.handleErrorOnCampaignInvitation(isRetried);
            });
        }
    };
    InfluencerAllSetComponent.prototype.handleErrorOnCampaignInvitation = function (isRetried) {
        this.isDeclined = true;
        this.title = this.translate.instant('all_set.rejected_title');
        if (!isRetried) {
            this.errorType = InfluencerRequestError.ACCEPT_OR_REJECT_API_FAIL;
        }
        this.modalService.openInCenter(this.allSetPageErrorModal, null, 'all-set-page-error-modal');
    };
    InfluencerAllSetComponent.prototype.loadInfluencerChannels = function (influencerId) {
        var _this = this;
        this.influencerService.getInfluencerChannels(influencerId).subscribe(function (res) {
            _this.listExistingChannel = res;
            var igChannels = _this.listExistingChannel.filter(function (ec) { return ec.platform.id === platformIconPath.instagram.id; });
            var nonConfirmedIgChannels = igChannels.filter(function (ic) { return _this.auth.hasAuthorizedIgChannel(ic.id); });
            _this.hasConfirmedAllChannels = nonConfirmedIgChannels.length === 0
                && _this.listExistingChannel.filter(function (cn) { return cn.type !== ChannelStatus.AUTHORIZED; }).length === 0;
        });
    };
    InfluencerAllSetComponent.prototype.updateInfluencerCampaignInvitation = function (status) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name) {
                _this.influencerService.acceptCampaignInvitation(_this.campaignId, _this.currentInfluencer.id)
                    .subscribe(function (res) {
                    resolve(res);
                }, function (error) {
                    reject(error);
                });
            }
            else if (status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name) {
                _this.influencerService.declineCampaignInvitation(_this.campaignId, _this.currentInfluencer.id)
                    .subscribe(function (res) {
                    resolve(res);
                }, function (error) {
                    reject(error);
                });
            }
        });
    };
    return InfluencerAllSetComponent;
}());
export { InfluencerAllSetComponent };



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-all-set/influencer-all-set.component.ts.pre-build-optimizer.js